import { AxiosResponse } from 'axios';
import KrpTechopsAdminResource from '@/api/resource/KrpTechopsAdminResource';
import { JobEntry } from './JobEntry';
import { JobExecution } from '../processing/JobExecution';

export default class JobResource extends KrpTechopsAdminResource {
  items: JobEntry[] = [];

  jobsPendingDirectorUrl: string = '/api/rcx/director/job/pending-processing';

  jobsProcessingDirectorUrl: string = '/api/rcx/director/job/jobs-running';

  jobsProcessingAscadUrl: string = '/api/fidil/ascad/job/pending-processing';

  jobsProcessingUffUrl: string = '/api/tran/uff-transformer/job/pending-processing';

  public async getAllPendingDirectorJobs(): Promise<JobEntry[]> {
    const response: AxiosResponse = await this.apiClient.get(this.jobsPendingDirectorUrl);

    this.items = response.data.data;
    return this.items;
  }

  public async getAllProcessingDirectorJobs(): Promise<JobEntry[]> {
    const response: AxiosResponse = await this.apiClient.get(this.jobsProcessingDirectorUrl);

    this.items = response.data.data;
    return this.items;
  }

  public async getAllProcessingAscadJobs(): Promise<JobEntry[]> {
    const response: AxiosResponse = await this.apiClient.get(this.jobsProcessingAscadUrl);
    return response.data.data;
  }

  public async getAllProcessingUffJobs(): Promise<JobEntry[]> {
    const response: AxiosResponse = await this.apiClient.get(this.jobsProcessingUffUrl);
    return response.data.data;
  }

  public async getAllSuccessfulProcessingJobExecutionsForDate(fiId: number, coreProcessingDate: string):
    Promise<JobExecution[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/director/${fiId}/job-execution/core-processing-date/${coreProcessingDate}`,
    );
    return response.data.data;
  }
}
